<div style="display: flex; justify-content: center; padding: 12px; font-family: Lato, sans-serif;">
    <h3 *ngIf="!receivedData">File processing happening for the selected pages</h3>
    <h3 *ngIf="receivedData">File processing completed, please click on close button to proceed</h3>
</div>
<mat-spinner style="align-self: center;" *ngIf="!receivedData"></mat-spinner>
<div *ngIf="receivedData" style="display: flex; justify-content: end; padding: 36px;">
    <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Close'" (click)="close()"></app-button>
</div>
